export default __webpack_public_path__ + "static/media/weDo.61b8d1a7.jpg";